export const withLoungeSGroups=[
    'orozco_cash_register_read',
    'orozco_cash_register_read_lounge',
    'place_read'
];
